import { render, staticRenderFns } from "./GiftcardForm.vue?vue&type=template&id=5765e9f0"
import script from "./GiftcardForm.vue?vue&type=script&lang=js"
export * from "./GiftcardForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports